import React from 'react';
import { Run } from './engine';

export function StepProgress({ run }: { run: Run }) {
    const group = ['opening', 'mechanic', 'boss'][run.stage];
    // Include cleared and upcoming objectives so the denominator stays stable.
    const objectives = run.objectives.filter(o => o.group === group);
    const total = objectives.reduce((sum, o) => sum + o.max, 0);
    const completed = objectives.filter(o => o.done).length;
    const progress = objectives.reduce((sum, o) => sum + (o.done ? o.max : Math.max(0, Math.min(o.max, o.max - o.hp))), 0);
    const percent = total > 0 ? Math.min(completed === objectives.length ? 100 : 99, Math.floor(progress / total * 100)) : 0;
    const ready = objectives.filter(o => !o.done && o.flags.loaded).length;
    const name = ['Opening', 'Mechanic', 'Boss'][run.stage];
    return <div className="step-progress">
        <div className="step-progress-label"><span>{name} progress</span><b>{percent}%</b></div>
        <div className="step-progress-track" role="progressbar" aria-label={`${name} progress`} aria-valuemin={0} aria-valuemax={100} aria-valuenow={percent}><i style={{ width: `${percent}%` }}/></div>
        <small>{completed}/{objectives.length} objectives complete{ready > 0 ? ` · ${ready} ready to fire` : ''}</small>
    </div>;
}
